<template>
    <div v-if="!isLoading" class="pl-lg-4" :key="'ldf'+tick">
        <form @submit.prevent="submitLocationDocument">
        <div class="row">
            <div v-if="isAdmin && typeof location === 'undefined'" class="col-lg-4">
                <label class="form-control-label">
                    Kunde
                    <span>*</span></label>
                <select v-model="locationDocument.customer"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <!-- <option value="" disabled selected>Kunde</option> -->
                    <option v-for="customer in customers" :key="customer.id" :value="customer['@id']">{{ customer.name }}
                    </option>
                </select>
            </div>
            <div v-if="customerData !== null && !isService && typeof location === 'undefined'" class="col-lg-4">
                <label class="form-control-label">
                    Standort
                    <span>*</span></label>
                <select v-model="locationDocument.location"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option v-for="loc in customerData.locations" :key="loc.id" :value="loc['@id']">{{ loc.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-2">
                <label class="form-control-label">
                    Erstausstellung?
                </label>
                <switches v-model="locationDocument.isFirst"
                          theme="bootstrap"
                          color="primary"
                          style="padding-left: 2rem;"
                          text-enabled="Ja, Erstausstellung"
                          text-disabled="Nein, wiederholte Ausstellung"></switches>

            </div>
            <!---
            <div class="col-lg-2">
                <label class="form-control-label">
                    Typ
                    <span>*</span></label>
                <select v-model="locationDocument.type"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option v-for="d in docOptions" :key="d" :value="d">{{ d }}
                    </option>
                </select>
            </div> --->
            <div class="col-md-10">
                <label class="form-control-label">
                    Bezeichnung
                </label>

                <vue-simple-suggest
                        v-model="locationDocument.name"
                        :list="items"
                        :styles="autoCompleteStyle"
                        display-attribute="name"
                        :filter-by-query="true">
                    <!-- Filter by input text to only show the matching results -->
                </vue-simple-suggest>

            </div>
        </div>
        <div class="row">
            <div class="col">
                <base-input alternative=""
                            required
                            label="Beschreibung"
                            input-classes="form-control-alternative form-control-lg"
                            v-model="locationDocument.description"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <label class="form-control-label">
                    Dokument
                    <span>*</span></label>
                <upload-field :url="uploadUrl"
                              v-model="locationDocument.document"
                              class="col-form-label col-form-label-lg"
                              input-classes=" form-control-lg input "
                              placeholder="Dokument auswählen oder von PC hochladen" ></upload-field>
            </div>
            <div class="col-lg-4">
                <base-input
                        label="Ausgestellt am:"
                        required
                        class="col-form-label col-form-label-lg"
                >
                    <flat-pickr slot-scope="{focus, blur}"
                                @on-open="focus"
                                @on-close="blur"
                                ref="pickr"
                                :config="config"
                                :class="['form-control','form-control-alternative','form-control-lg','datepicker']"
                                v-model="locationDocument.issuedAt">
                    </flat-pickr>
                </base-input>
            </div>
            <div class="col-lg-4">
                <base-input
                        label="Läuft ab am:"
                        required
                        class="col-form-label col-form-label-lg"
                >
                    <flat-pickr slot-scope="{focus, blur}"
                                @on-open="focus"
                                @on-close="blur"
                                ref="pickr"
                                :config="config"
                                :class="['form-control','form-control-alternative','form-control-lg','datepicker']"
                                v-model="locationDocument.invalidAt">
                    </flat-pickr>
                </base-input>
            </div>
        </div>
        <button class="btn btn-icon my-4 btn-primary" :disabled="isSending">
            <span class="btn-inner--icon"><i v-if="isSending" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
            <span class="btn-inner--text">Dokument {{(typeof locationDocument['@id'] === "undefined") ?  'anlegen' : 'ändern'}}</span></button>
        </form>
    </div>
    <div v-else class="pl-lg-4 text-center">
        <!---<i class="fas fa-5x fa-circle-notch fa-spin py-5"></i>---->
        <font-awesome-icon icon="circle-notch" size="6x" spin/>
    </div>
</template>
<script>
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import { German } from "flatpickr/dist/l10n/de.js";
    import UploadField from "@/components/UploadField/UploadField";
    import Switches from "vue-switches";


    export default {
        name:"location-document-form",
        components:{flatPickr, Switches, UploadField},
        props:{
            edit:{
                type:Boolean,
                default:false,
                description:"Is edit??"
            },
            location: {
                type: String,
                default: undefined,
                description: 'location ID'
            },
            type:
                {
                    type: String,
                    default: '',
                    description: 'location document Name'
                },
            loadingProp: {
                type: Boolean,
                default: false,
                description: 'is Loading Prop'
            }
        },
        data() {
            return {
                docOptions: ['Zertifikat','Schulung','Unterweisung', 'Sonstiges'],
                locationDocument: {
                    isFirst: false,
                    document: null,
                    location: null,
                    customer: null,
                    user: null,
                    type: 'standard',
                    name: '',
                    description: '',
                    invalidAt: null,
                    issuedAt: null,
                },
                isLoadingData: false,
                uploadUrl: process.env.VUE_APP_API_SERVER +'/api/documents',
                config: {
                    dateFormat: 'Y-m-d',
                    altFormat: 'd.m.Y',
                    altInput: true,
                    allowInput: true,
                    locale: German
                },
                items: [
                    { id: 1, name: 'Konzession'},
                    { id: 2, name: 'Sozialkonzept'},
                    { id: 3, name: 'Aufstellerlaubnis'},
                    { id: 4, name: 'Sonstige'},
                ],
                autoCompleteStyle : {
                    vueSimpleSuggest: "position-relative",
                    inputWrapper: "input-wrapper",
                    defaultInput : "form-control form-control-alternative form-control-lg",
                    suggestions: "position-absolute list-group z-100-overflow",
                    suggestItem: "list-group-item"
                },
                isSending: false,
                tick: 1
            }
        },
        created(){
            this.isLoadingData = true;
            //todo predefine array ...
            Promise.all([this.$store.dispatch('customer/getCustomerCollection')]).then(() => {
                this.init();
                this.isLoadingData = false;
            });

        },
        computed: {
            customers() {
                return this.$store.getters['customer/showCustomerCollection'];
            },
            customerData() {
                return (this.$store.getters['customer/isReady'] && this.locationDocument.customer !== null) ? this.$store.getters['customer/showCustomerByIRI'](this.locationDocument.customer) : {customer:{id:0,name: 'placeholder'}};
            },
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            isService() {
                return this.$store.getters['authentication/isService'];
            },
            availableOptions() {
                return this.options.filter(opt => this.locationDocument.type.indexOf(opt) === -1)
            },
            isLoading() {
                return this.isLoadingData || this.loadingProp;
            }
        },
        methods:{
            init() {
                if (!this.edit) {
                    this.locationDocument.customer = this.$store.getters['location/showLocationByIRI'](this.location).customer['@id'];
                    this.locationDocument.location = this.location;
                }
                this.tick++;
            },
            submitLocationDocument() {
                return new Promise(() => {
                    let type = (typeof this.locationDocument['@id'] === 'undefined') ? 'POST' : 'PATCH';
                    let url = (typeof this.locationDocument['@id'] === 'undefined') ? '/api/location_documents' : '/api/location_documents/' + this.locationDocument.id;
                    let ctype = (typeof this.locationDocument['@id'] === 'undefined') ? 'application/json' : 'application/merge-patch+json';
                    let msg = (typeof this.locationDocument['@id'] === 'undefined') ? 'angelegt.' : 'geändert.';
                    const header = this.authHeader();
                    header['Content-Type'] = ctype;
                    let senddata = this.locationDocument;
                    const requestOptions = {
                        method:type,
                        headers:header,
                        body:JSON.stringify(senddata)
                    };
                    this.isSending = true;
                    this.tick++;
                    fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isSending = false;
                                this.$store.dispatch('alert/success', 'Dokument "' + response.name + '" (ID: ' + response.id + ') erfolgreich ' + msg);
                                this.tick++;
                                this.$emit('locationDocumentCreated')
                            },
                            error => {
                                this.isSending = false;
                                this.$store.dispatch('alert/error', error);

                                this.tick++;
                            });

                });
            }
        }
    }
</script>

<style scoped>

</style>